export default __webpack_public_path__ + "static/media/Asahi America.a5d039e7.png";